import { Heart } from 'lucide-react';

export function Footer() {
  return (
    <footer className="border-t border-surface-200 py-8">
      <div className="max-w-6xl mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2 text-surface-500">
            <span>Built with</span>
            <Heart size={14} className="text-red-500 fill-red-500" />
            <span>using Cloudflare</span>
          </div>
          <div className="flex items-center gap-6 text-sm text-surface-500">
            <a href="/feed.xml" className="hover:text-surface-900 transition-colors">RSS</a>
            <a href="/sitemap.xml" className="hover:text-surface-900 transition-colors">Sitemap</a>
            <a href="/admin" className="hover:text-surface-900 transition-colors">Admin</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
